

import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { themeV5 } from 'theme/v5'

const ServiceBookings = ({ children }) => {
  return (
    <Card
      sx={{
        boxShadow: 'none',
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        borderBottomRightRadius: '5px',
        borderBottomLeftRadius: '5px',
      }}>
      <CardContent
        sx={{
          p: 3
        }}>
        <Stack
          border='1px solid'
          borderColor={themeV5.palette.accent.sky}
          padding={2}
          borderRadius={1}
          gap={2}>
          <Stack>
            <Typography variant="h5" fontWeight={600}>
              Service Bookings
            </Typography>
            <Typography variant="bodyMedium" fontWeight={300}>
              Add booking details or confirm a completed booking
            </Typography>
          </Stack>
          {children}
        </Stack>
      </CardContent>
    </Card>
  )
}

export default ServiceBookings
